class Product {
  constructor() {
    this.acc = [];
    this.container = document.querySelector(".m-main-product");
    MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState();
    MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState();
    this.addRecentViewedProduct();

    //BOBO paris
// add pay now button

// Fonction pour récupérer le paramètre "v" dans l'URL
function getVariantId() {
  const params = new URLSearchParams(window.location.search);
  const variantParams = params.get('variant');

  if (variantParams) return variantParams;


  const productJson = JSON.parse(document.getElementById('productVariants').textContent);
  
  console.log(productJson);

  if (!productJson.length) return null
  return  productJson[0]?.id// retourne le variant ID
}

document.getElementById("fake-buy-now").addEventListener("click", function () {
  const variantId = getVariantId()

  console.log('variant ID', variantId)
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => response.json())
  .then(() => {
    window.location.href = '/checkout';
  })
  .catch(error => console.error('Erreur:', error));
});


    addEventDelegate({
      context: this.container,
      selector: (window.__minimog_review_selector || '') + '.m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview',
      handler: (e) => {
      const index = e.target.closest('.m-product-collapsible').dataset.index
      setTimeout(() => {
        this.acc[Number(index)].setContentHeight()
      }, 300)},
      capture: true
    })
  }

  addRecentViewedProduct() {
    const cookies = getCookie('m-recent-viewed-products')
    let products = cookies ? JSON.parse(cookies) : []
    if (products.indexOf(MinimogSettings.productHandle) === -1) {
      products.unshift(MinimogSettings.productHandle)
      products = products.slice(0, 20)
      setCookie('m-recent-viewed-products', JSON.stringify(products));
    }
  }
}

// new Product();
